export default __webpack_public_path__ + "static/media/3.af46f278.webp";